export class FileUploadResult {
  constructor(public fileId: string, public fileName: string) {}
}
